import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { expensesApi } from 'src/Services/API';

interface SetRecurrenceOccurrenceAmountVariables {
  templateExpenseId: string;
  date: string;
  amount: number;
}

export const useSetRecurrenceOccurrenceAmount = () => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      templateExpenseId,
      date,
      amount,
    }: SetRecurrenceOccurrenceAmountVariables) => {
      if (!assetId) throw new Error('No asset selected');
      await expensesApi.expensesControllerSetRecurrenceOccurrenceAmount(
        templateExpenseId,
        assetId,
        {
          date,
          amount,
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fetch-budget-forecast-view', assetId] });
    },
  });
};
